export default __webpack_public_path__ + "img/34.a14e1e5.svg";